import React from 'react';
import { format } from 'date-fns';
import PropTypes from 'prop-types';

import ProgressLoader from 'components/essentials/ProgressLoader/ProgressLoader';

import CheckoutSubmitButton from '../../CheckoutSubmitButton';
import ShippingGroup from './ShippingGroup';

const ShippingGroups = ({
  goToTab,
  deliveryInfo,
  shippingGroups,
  hasProtectionNext,
  updateDeliveryInfo,
  shippingGroupsLoading,
  cartData,
  avoCheckoutStepCompleted,
  shipping,
}) => {
  const setDeliveryInfo = ({
    deliverySelection: delivery_selection,
    productionSelection: production_selection,
    productionSelectionAdd: production_selection_add,
  }) => {
    const updatedDeliveryInfo = { ...deliveryInfo };

    if (delivery_selection) {
      updatedDeliveryInfo.delivery_selection = {
        ...updatedDeliveryInfo.delivery_selection,
        ...delivery_selection,
      };
    }

    if (production_selection) {
      updatedDeliveryInfo.production_selection = {
        ...updatedDeliveryInfo.production_selection,
        ...production_selection,
      };
    }

    if (production_selection_add) {
      updatedDeliveryInfo.production_selection_add = {
        ...updatedDeliveryInfo.production_selection_add,
        ...production_selection_add,
      };
    }

    updateDeliveryInfo(updatedDeliveryInfo);
  };

  const updateDelayedShippingDates = (groupId, delayedDelivery) => {
    const updatedDeliveryInfo = { ...deliveryInfo };

    updatedDeliveryInfo.production_selection_add = {
      ...updatedDeliveryInfo.production_selection_add,
      [groupId]: format(new Date(delayedDelivery.startDate), 'yyyy-MM-dd'),
    };

    updateDeliveryInfo(updatedDeliveryInfo);
  };

  const proceedToNextTab = () => {
    goToTab(hasProtectionNext ? 'protection' : 'payment');
    avoCheckoutStepCompleted({ step: 3 });
  };

  const {
    delivery_selection,
    production_selection,
    production_selection_add,
  } = deliveryInfo;

  if (shippingGroupsLoading) {
    return <ProgressLoader />;
  }

  return (
    <div
      data-xc="delivery-form"
      className='delivery [&_div[role="radiogroup"]]:!ml-[5px]'
    >
      {shippingGroups.map((group, index) => (
        <ShippingGroup
          group={group}
          key={group.id}
          groupNumber={index + 1}
          deliverySelection={delivery_selection}
          productionSelection={production_selection}
          productionSelectionAdd={production_selection_add}
          updateDeliveryInfo={setDeliveryInfo}
          updateDelayedShippingDates={updateDelayedShippingDates}
          cartData={cartData}
          shipping={shipping}
        />
      ))}

      <div className="flex justify-end my-[30px]">
        <CheckoutSubmitButton
          id="protection-or-billing-btn"
          dataXc="delivery-button"
          onClick={proceedToNextTab}
        >
          Continue to {hasProtectionNext ? 'protection' : 'Billing'}
        </CheckoutSubmitButton>
      </div>
    </div>
  );
};

ShippingGroups.propTypes = {
  avoCheckoutStepCompleted: PropTypes.func,
  cartData: PropTypes.object,
  deliveryInfo: PropTypes.shape({
    delivery_selection: PropTypes.object,
    production_selection: PropTypes.object,
    production_selection_add: PropTypes.object,
  }),
  goToTab: PropTypes.func,
  hasProtectionNext: PropTypes.bool,
  shippingGroups: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    })
  ),
  shippingGroupsLoading: PropTypes.bool,
  updateDeliveryInfo: PropTypes.func,
  shipping: PropTypes.object,
};

export default ShippingGroups;
